import React from 'react';
import Container from 'react-bootstrap/Container';
import Carousel from 'react-bootstrap/Carousel';
import '../styles/heroSection/Hero.min.css';

const images = [
    '/images/hero-section-img/hero-image1.png',
    '/images/hero-section-img/hero-image2.png',
    '/images/hero-section-img/hero-image3.png',
  '/images/hero-section-img/hero-image4.png'
]

const HeroSection = () => {
  return (
      <>
      <Carousel controls indicators interval={7000} wrap={true} className="custom-carousel">
      {images.map((image, index) => (
        <Carousel.Item key={index} className="carousel-background">
          <img className="d-block w-100 carousel-image" src={image} alt={`Slide ${index + 1}`} />
        </Carousel.Item>
      ))}
    </Carousel>
      <div className="carousel-text bg-transp d-flex justify-content-center align-items-center text-center">
        <h1 className='bg-transp m-0'>Os <strong className='carousel-text-accent bg-transp'>jovens</strong> são o <strong className='carousel-text-accent bg-transp'>presente</strong> <br/>que transforma o <strong className='carousel-text-accent bg-transp'>futuro</strong>!</h1>
      </div>
      
      </>
    );
}

export default HeroSection;